import { useEffect, useState } from "react";
import * as Yup from 'yup'
import { useListView } from "./contact-details/core/ListViewProvider";
import { isNotEmpty, KTCard, KTCardBody, QUERIES } from "../../../_dashboard/helpers";
import { useQuery } from "react-query";
import { getOneById } from "../../services/common_requests";
import { useFormik } from "formik";
import _ from 'lodash';
import ReactQuill from "react-quill";
import ImageEditModal from "../hotel-management/hotel-details/image-edit-modal/ImageEditModal";
import { images } from "../hotel-management/hotel-details/core/_models";
import { useIntl } from "react-intl";

const Contact: React.FC = () => {
    const intl = useIntl();
    const validationSchema = Yup.object().shape({

    })
    const { itemIdForUpdate, setItemIdForUpdate } = useListView()
    const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
    const {
        isLoading,
        data: Contact,
        error,
    } = useQuery(
        `${QUERIES.CONTACT_PAGE}-Contact-${itemIdForUpdate}`,
        () => {
            if (!itemIdForUpdate) {
                throw new Error("ID is undefined");
            }
            return getOneById(itemIdForUpdate, "/Contact")
        },
        {
            cacheTime: 0,
            enabled: enabledQuery,
            onError: (err) => {
                setItemIdForUpdate(undefined)
                console.error(err)
            },
        }
    )
    const initialValues = Contact ? {
        id: Contact._id,
        description: Contact.description,
        image: Contact.image,
        email: Contact.contact.email,
        phone: Contact.contact.phone,
        adress: Contact.contact.adress,
        seoUrl: Contact.seourl,
        fbUrl: Contact.fbUrl,
        instaUrl: Contact.instaUrl,
        tiktokUrl: Contact.tiktokUrl,
        youtubeUrl: Contact.youtubeUrl,
    } : {
        id: '',
        description: 'L évasion parfaite, luxe et détente au cœur du paradis !...',
        image: 'https://xml.beachhotelsresorts.tn/file_manager/source/Iris Djerba Thalasso/AnyConv-com__HBG00173-HDR (1).webp',
        email: '',
        adress: '',
        seoUrl: "Contact-alt"
    };
    const formik = useFormik({
        initialValues,
        onSubmit: async (values) => {
            console.log("Form submitted with values:", values);
            const modifiedFields = Object.keys(values).reduce((acc, key) => {
                const typedKey = key as keyof typeof values;
                if (!_.isEqual(values[typedKey], initialValues[typedKey])) {
                    acc[typedKey] = values[typedKey];
                }
                return acc;
            }, {} as Record<string, any>);
            console.log("Modified fields:", JSON.stringify(modifiedFields));

            try {
                const response = await fetch('https://your-api-endpoint.com/upload', {
                    method: 'POST',
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                console.log('Success:', data);
            } catch (error) {
                console.error('Error:', error);
            }
        },
    });
    console.log('*****////' + Contact?._id)
    useEffect(() => {
        if (Contact) {
            formik.setValues({
                id: Contact._id,
                description: Contact.description,
                image: Contact.image,
                email: Contact.contact.email,
                phone: Contact.contact.phone,
                adress: Contact.contact.adress,
                seoUrl: Contact.seourl,
                fbUrl: Contact.fbUrl,
                instaUrl: Contact.instaUrl,
                tiktokUrl: Contact.tiktokUrl,
                youtubeUrl: Contact.youtubeUrl,

            });
        }
    }, [Contact]);
    return (
        <>
            <KTCard>
                <KTCardBody className='py-4'>
                    <div className='py-4 app-content flex-column-fluid'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <h3 className='mb-6'>{intl.formatMessage({ id: 'CONTACT.TITLE' })}</h3>
                                <form onSubmit={formik.handleSubmit}>
                                    <div className='form-group  mb-4'>
                                        <label className='me-3 mb-3' >
                                            <strong>{intl.formatMessage({ id: 'COMMUN.SECTION_ONE' })}</strong>
                                        </label>

                                        <div className='form-group mb-4'>
                                            <div className='d-flex flex-wrap align-items-center'>
                                                <div className='col-12  mb-3 me-4'>
                                                    <label className='me-3 mb-3' >
                                                        <strong> {intl.formatMessage({ id: 'HEADER.EMAIL' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100'
                                                        name='email'
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.email && formik.errors.email && (
                                                        <div className='text-danger'>{formik.errors.email as string}</div>
                                                    )}
                                                </div>
                                                <div className="col-12  mb-3 me-4">
                                                    <label className='me-3 mb-3' >
                                                        <strong>{intl.formatMessage({ id: 'FOOTER.DESCRIPTION' })}</strong>
                                                    </label>

                                                    <ReactQuill
                                                        value={formik.values.description}
                                                        onChange={(value) => formik.setFieldValue('description', value)}
                                                        onBlur={() => formik.setFieldTouched('description', true)}
                                                        modules={{
                                                            toolbar: [
                                                                ['bold', 'italic', 'underline', 'strike'],
                                                                ['blockquote'],
                                                                [{ 'header': 1 }, { 'header': 2 }],
                                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                                [{ 'indent': '-1' }, { 'indent': '+1' }],
                                                                [{ 'direction': 'rtl' }],
                                                                [{ 'size': ['small', false, 'large', 'huge'] }],
                                                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                                [{ 'font': [] }],
                                                                ['clean']
                                                            ],
                                                        }}
                                                        formats={[
                                                            'header', 'font', 'size',
                                                            'bold', 'italic', 'underline', 'strike', 'blockquote',
                                                            'list', 'indent',
                                                            'link', 'image', 'video'
                                                        ]}
                                                    />
                                                    {formik.touched.description && formik.errors.description && (
                                                        <div className="text-danger">{formik.errors.description as string}</div>
                                                    )}
                                                </div>

                                            </div>
                                            <div className='form-group mb-4'>
                                            <div className='d-flex flex-wrap align-items-center'>
                                            <div className='col-12 col-md-auto mb-4 me-4'>
                                                    <label className='me-3 mb-3' >
                                                        <strong> Email :</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='email'
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.email && formik.errors.email && (
                                                        <div className='text-danger'>{formik.errors.email as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                        <strong>{intl.formatMessage({ id: 'FOOTER.PHONE' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='phone'
                                                        value={formik.values.phone}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.phone && formik.errors.phone && (
                                                        <div className='text-danger'>{formik.errors.phone as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                    <strong>{intl.formatMessage({ id: 'FOOTER.ADDRESS' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100  w-md-auto'
                                                        name='adress'
                                                        value={formik.values.adress}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        
                                                    />
                                                    {formik.touched.adress && formik.errors.adress && (
                                                        <div className='text-danger'>{formik.errors.adress as string}</div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        </div>

                                    </div>

                                    <div className='separator mb-4'></div>


                                    <div className="modal-footer">
                                        <button type='submit' className='btn btn-primary me-2'>{intl.formatMessage({ id: 'HEADER.SAVE' })}</button>
                                        <button type="button" className="btn btn-secondary">{intl.formatMessage({ id: 'HEADER.RESET' })}</button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </>
    )
}

export { Contact }
